/**
 * Valid values for the public sharing state of publicly shareable items.
 */
export enum PublicSharingState {
    MARKED_FOR_SHARING = 'marked_for_sharing',
    MARKED_FOR_UNSHARING = 'marked_for_unsharing',
    NOT_SHARED = 'not_shared',
    SHARED = 'shared',
    APPROVED_FOR_UNSHARING = 'approved_for_unsharing',
    APPROVED_FOR_SHARING = 'approved_for_sharing',
}
